<app-section #parentSection
             *ngIf="canHandle"
             [title]="title"
             [key]="key"
             [sectionRef]="section"
             [formGroup]="formGroup"
             class="cession-section"
             [formConfig]="formConfig">

    <ng-template #section>

        <div class="section__component col cession-section__is-cession">
            <app-radio *ngIf="isFieldTypeRadio(consts.IS_CESSION)"
                       [bean]="bean"
                       [errorsMap]="formFactoryService.errorsMap"
                       [control]="formGroup.controls[consts.IS_CESSION]"
                       [fieldConfig]="formFactoryService.fieldConfig(consts.IS_CESSION, formConfig)"
                       [context]="formConfig.formKey"
                       (changeEvent)="onFieldChange($event)"
                       (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
            >
            </app-radio>

            <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.IS_CESSION)"
                       [bean]="bean"
                       [errorsMap]="formFactoryService.errorsMap"
                       [control]="formGroup.controls[consts.IS_CESSION]"
                       [fieldConfig]="formFactoryService.fieldConfig(consts.IS_CESSION, formConfig)"
                       [context]="formConfig.formKey"
                       (changeEvent)="onFieldChange($event)"
                       (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
            >
            </app-button-toggle>
        </div>
        <div *ngIf="isCession" class="col">
            <div class="section__component col-50">
                <app-text-field
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.POSTAL_CODE]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.POSTAL_CODE, formConfig)"
                        [context]="formConfig.formKey"
                        (changeEvent)="onFieldChange($event)"
                        (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-text-field>
            </div>
            <div class="section__component col-50">
                <app-select
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.BANK_ID]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.BANK_ID, formConfig)"
                        [context]="formConfig.formKey"
                        (changeEvent)="onFieldChange($event)"
                        (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-select>
            </div>
            <div class="section__component col-50">
                <app-text-field
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.AMOUNT]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.AMOUNT, formConfig)"
                        [context]="formConfig.formKey"
                        (changeEvent)="onFieldChange($event)"
                        (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-text-field>
            </div>
        </div>

    </ng-template>
</app-section>
